import {
  FETCH_CLASSIFICATIONS_REQUEST,
  FETCH_CLASSIFICATIONS_SUCCESS,
  FETCH_CLASSIFICATIONS_FAILURE,
  SAVE_CLASSIFICATION_REQUEST,
  SAVE_CLASSIFICATION_SUCCESS,
  SAVE_CLASSIFICATION_FAILURE,
  DELETE_CLASSIFICATION_REQUEST,
  DELETE_CLASSIFICATION_SUCCESS,
  DELETE_CLASSIFICATION_FAILURE,
} from './types';

const INITIAL_STATE = {
  classificationList: [],
  loading: false,
  error: null,
};

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case FETCH_CLASSIFICATIONS_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case FETCH_CLASSIFICATIONS_SUCCESS:
      return {
        ...state,
        loading: false,
        classificationList: action.payload,
      };

    case FETCH_CLASSIFICATIONS_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload.error,
        classificationList: [],
      };
    case SAVE_CLASSIFICATION_REQUEST:
      return {
        ...state,
        error: null,
      };

    case SAVE_CLASSIFICATION_SUCCESS:
      return {
        ...state,
      };

    case SAVE_CLASSIFICATION_FAILURE:
      return {
        ...state,
        error: action.payload.error,
      };

    case DELETE_CLASSIFICATION_REQUEST:
      return {
        ...state,
        error: null,
      };

    case DELETE_CLASSIFICATION_SUCCESS:
      return {
        ...state,
      };

    case DELETE_CLASSIFICATION_FAILURE:
      return {
        ...state,
        error: action.payload.error,
      };
    default:
      // ALWAYS have a default case in a reducer
      return state;
  }
};
